module.exports = new __parcel__URL__("error.b7de7f77.svg").toString();